import PropTypes from 'prop-types';

const ItemsInOrderTableDescriptorTag = ({
  className = '',
  icon: Icon,
  iconClassName = 'me-1',
  textSize = 'xs',
  title
}) => {
  const textSizeClass = `text-${textSize}`;
  const textColorClass = 'u-color--DarkGray';
  return (
    <div className={`d-flex align-items-baseline ${className}`}>
      <span className={`${iconClassName} mb-0`}>
        <Icon height={16} width={16} />
      </span>
      <p className={`exclude-global mb-0 ${textSizeClass} ${textColorClass}`}>
        {title}
      </p>
    </div>
  );
};

ItemsInOrderTableDescriptorTag.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  iconClassName: PropTypes.string,
  textSize: PropTypes.string,
  title: PropTypes.string
};

export default ItemsInOrderTableDescriptorTag;
